import React, { ReactNode } from "react";

import AnyColor from "@mapmycustomers/shared/types/AnyColor";

import Dashboard from "@app/types/dashboard/Dashboard";

import styles from "./BaseHeader.module.scss";
import Gradient from "./Gradient";

interface Props {
  auto?: boolean;
  children: ReactNode;
  colors?: AnyColor[];
  editable?: boolean;
  logoUrl?: string;
  onGradientChange?: (
    settings: Partial<Pick<Dashboard["settings"], "gradient" | "gradientFromImage">>
  ) => void;
}

const BaseHeader: React.FC<Props> = ({
  auto,
  children,
  colors,
  editable,
  logoUrl,
  onGradientChange,
}) => {
  return (
    <div className={styles.container}>
      <Gradient
        auto={auto}
        colors={colors}
        editable={editable}
        logoUrl={logoUrl}
        onChange={onGradientChange}
      />
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default BaseHeader;
